"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBorMeasureMultiCampsExpr = getBorMeasureMultiCampsExpr;
exports.getCohortedBorMeasureMultiCampExpr = getCohortedBorMeasureMultiCampExpr;
const lodash_set_1 = __importDefault(require("lodash.set"));
const query_1 = require("../query");
const cohorts_1 = require("./cohorts");
const numericMeasures_1 = require("./numericMeasures");
const queryMapBorMeasures_1 = require("./queryMapBorMeasures");
const queryMapCohorted_1 = require("./queryMapCohorted");
const getRoasEventsPerCampCondition = (roasEventsInCampaignsMap = {}) => Object.entries(roasEventsInCampaignsMap)
    .filter(([, roasEventsInCampaign]) => roasEventsInCampaign === null || roasEventsInCampaign === void 0 ? void 0 : roasEventsInCampaign.length)
    .map(([campaignId, roasEventsInCampaign]) => ({
    $and: [
        { $eq: ["CAMPAIGN_ID", campaignId] },
        { $in: ["EVENT_NAME", roasEventsInCampaign !== null && roasEventsInCampaign !== void 0 ? roasEventsInCampaign : []] },
    ],
}));
function getBorMeasureMultiCampsExpr({ eventName, roasEventsInCampaignsMap, onException, }) {
    let mmpRoasEventsInCampaignsMap = {};
    let skanRoasEventsInCampaignsMap = {};
    Object.entries(roasEventsInCampaignsMap !== null && roasEventsInCampaignsMap !== void 0 ? roasEventsInCampaignsMap : {}).forEach(([campId, events]) => {
        mmpRoasEventsInCampaignsMap[campId] =
            (0, queryMapBorMeasures_1.getNonSkanEventsFromRoasEvents)(events);
        skanRoasEventsInCampaignsMap[campId] = (0, queryMapBorMeasures_1.getSkanEventsFromRoasEvents)(events);
    });
    const mmpRoasEventsPerCampCondition = getRoasEventsPerCampCondition(mmpRoasEventsInCampaignsMap);
    const skanRoasEventsPerCampCondition = getRoasEventsPerCampCondition(skanRoasEventsInCampaignsMap);
    if (mmpRoasEventsPerCampCondition.length) {
        if (eventName === numericMeasures_1.Events.sales) {
            const singleCampExpr = (0, query_1.countMultiTemplate)([]);
            const multiCampsExpr = (0, lodash_set_1.default)(singleCampExpr, ["expr", "$sum", "where"], [{ $or: mmpRoasEventsPerCampCondition }]);
            return multiCampsExpr;
        }
        if (eventName === numericMeasures_1.Events.revenue) {
            const singleCampExpr = (0, query_1.countMultiValueMultiTemplate)([]);
            const multiCampsExpr = (0, lodash_set_1.default)(singleCampExpr, ["expr", "$sum", "where"], [{ $or: mmpRoasEventsPerCampCondition }]);
            return multiCampsExpr;
        }
        if (eventName === numericMeasures_1.Metrics.roas) {
            const singleCampExpr = (0, query_1.divTemplate)((0, query_1.mulTemplate)((0, query_1.countMultiValueMultiTemplate)([]), 1000000), (0, query_1.aliasExprTemplate)("$SPENT"));
            const multiCampsExpr = (0, lodash_set_1.default)(singleCampExpr, [
                "expr",
                "$div",
                "args",
                "0",
                "expr",
                "$mul",
                "args",
                "0",
                "expr",
                "$sum",
                "where",
            ], [{ $or: mmpRoasEventsPerCampCondition }]);
            return multiCampsExpr;
        }
        if (eventName === numericMeasures_1.Metrics.cpa) {
            const singleCampExpr = (0, query_1.divTemplate)((0, query_1.aliasExprTemplate)("$SPENT"), (0, query_1.countMultiTemplate)([]));
            const multiCampsExpr = (0, lodash_set_1.default)(singleCampExpr, ["expr", "$div", "args", "1", "expr", "$sum", "where"], [{ $or: mmpRoasEventsPerCampCondition }]);
            return multiCampsExpr;
        }
    }
    if (skanRoasEventsPerCampCondition.length) {
        const skanRoasEventsInCampaignsMap = {};
        for (let [cId, events] of Object.entries(roasEventsInCampaignsMap !== null && roasEventsInCampaignsMap !== void 0 ? roasEventsInCampaignsMap : {})) {
            skanRoasEventsInCampaignsMap[cId] =
                events && (0, queryMapBorMeasures_1.getSkanEventsFromRoasEvents)(events);
        }
        const skanRoasEventsPerCampCondition = getRoasEventsPerCampCondition(skanRoasEventsInCampaignsMap);
        if (!skanRoasEventsPerCampCondition.length) {
            return query_1.DUMMY_EXPRESSION;
        }
        const singleCampExpr = (0, query_1.divTemplate)((0, query_1.aliasExprTemplate)("$SPENT"), (0, query_1.countMultiTemplate)([]));
        const multiCampsExprCpa = (0, lodash_set_1.default)(singleCampExpr, ["expr", "$div", "args", "1", "expr", "$sum", "where"], [{ $or: skanRoasEventsPerCampCondition }]);
        if (eventName === numericMeasures_1.Metrics.skanCpa) {
            return multiCampsExprCpa;
        }
        if (eventName === numericMeasures_1.Metrics.skanPcpa) {
            return multiCampsExprCpa; //TODO cattt rethink what is formula here
        }
    }
    return query_1.DUMMY_EXPRESSION;
}
function getCohortedBorMeasureMultiCampExpr({ eventName, cohort, roasEventsInCampaignsMap, onException, }) {
    if (!roasEventsInCampaignsMap)
        return query_1.DUMMY_EXPRESSION;
    let mmpRoasEventsInCampaignsMap = {};
    Object.entries(roasEventsInCampaignsMap !== null && roasEventsInCampaignsMap !== void 0 ? roasEventsInCampaignsMap : {}).forEach(([campId, events]) => {
        mmpRoasEventsInCampaignsMap[campId] =
            (0, queryMapBorMeasures_1.getNonSkanEventsFromRoasEvents)(events);
    });
    const mmpRoasEventsPerCampCondition = getRoasEventsPerCampCondition(mmpRoasEventsInCampaignsMap);
    const cohortCondition = (0, queryMapCohorted_1.getCohortCondition)(cohort);
    if (mmpRoasEventsPerCampCondition.length) {
        const mmpRoasEventsInCampaignsMap_COHORT = Object.entries(mmpRoasEventsInCampaignsMap).reduce((acc, [cId, events]) => {
            acc[cId] = events && (events === null || events === void 0 ? void 0 : events.map(cohorts_1.makeCohortableCustomEventName));
            return acc;
        }, {});
        const notCohortedExpr = getBorMeasureMultiCampsExpr({
            eventName,
            roasEventsInCampaignsMap: mmpRoasEventsInCampaignsMap_COHORT,
        });
        if (notCohortedExpr === query_1.DUMMY_EXPRESSION) {
            return notCohortedExpr;
        }
        if (eventName === numericMeasures_1.Events.sales) {
            return (0, query_1.withCondition)(notCohortedExpr, cohortCondition);
        }
        if (eventName === numericMeasures_1.Events.revenue) {
            return (0, query_1.withCondition)(notCohortedExpr, cohortCondition);
        }
        if (eventName === numericMeasures_1.Metrics.roas) {
            return (0, query_1.withCondition)(notCohortedExpr, cohortCondition, [
                "$div",
                "args",
                "0",
                "expr",
                "$mul",
                "args",
                "0",
                "expr",
                "$sum",
            ]);
        }
        if (eventName === numericMeasures_1.Metrics.cpa) {
            return (0, query_1.withCondition)(notCohortedExpr, cohortCondition, [
                "$div",
                "args",
                "1",
                "expr",
                "$sum",
            ]);
        }
    }
    return query_1.DUMMY_EXPRESSION;
}
